import { render } from "./header.vue?vue&type=template&id=2ae4d219&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=2ae4d219&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae4d219"],['__file',"src/components/global/header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ae4d219"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ae4d219', __exports__)) {
    api.reload('2ae4d219', __exports__)
  }
  
  module.hot.accept("./header.vue?vue&type=template&id=2ae4d219&scoped=true", () => {
    api.rerender('2ae4d219', render)
  })

}


export default __exports__